"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insuranceProviderContact = void 0;
const insuranceProviderList = [
    { id: '21st Century Insurance', value: '21st Century Insurance' },
    { id: 'ACCC Insurance Co.', value: 'ACCC Insurance Co.' },
    { id: 'Access Home Insurance Co.', value: 'Access Home Insurance Co.' },
    { id: 'Accident Insurance Co.', value: 'Accident Insurance Co.' },
    { id: 'ACE', value: 'ACE' },
    { id: 'ACUITY A Mutual Insurance Co.', value: 'ACUITY A Mutual Insurance Co.' },
    { id: 'Aegis Security Insurance Co.', value: 'Aegis Security Insurance Co.' },
    { id: 'Agency Insurance Co. of MD Inc', value: 'Agency Insurance Co. of MD Inc' },
    { id: 'Agents Mutual Insurance Co.', value: 'Agents Mutual Insurance Co.' },
    { id: 'AgWorkers Insurance', value: 'AgWorkers Insurance' },
    { id: 'AIG', value: 'AIG' },
    { id: 'AIG Insurance Co. - PR', value: 'AIG Insurance Co. - PR' },
    { id: 'AIG Property Casualty U.S. Inc', value: 'AIG Property Casualty U.S. Inc' },
    { id: 'Aioi Nissay Dowa Ins Co. Ltd.', value: 'Aioi Nissay Dowa Ins Co. Ltd.' },
    { id: "Alamance Farmers' Mutl Ins Co.", value: "Alamance Farmers' Mutl Ins Co." },
    { id: 'Alfa Mutual', value: 'Alfa Mutual' },
    { id: 'Alinsco Insurance Co.', value: 'Alinsco Insurance Co.' },
    { id: 'Allegany Insurance', value: 'Allegany Insurance' },
    { id: 'Alliance United', value: 'Alliance United' },
    { id: 'Allianz Global Risks US Ins Co', value: 'Allianz Global Risks US Ins Co' },
    { id: 'ALLIED', value: 'ALLIED' },
    { id: 'Allied Insurance Co of America', value: 'Allied Insurance Co of America' },
    { id: 'Allied Trust Insurance Co.', value: 'Allied Trust Insurance Co.' },
    { id: 'Allied World Assurance Co.', value: 'Allied World Assurance Co.' },
    { id: 'Allstate', value: 'Allstate' },
    { id: 'Amer Integrity Ins Co FL', value: 'Amer Integrity Ins Co FL' },
    { id: 'Amer Modern', value: 'Amer Modern' },
    { id: 'American Access Casualty Co.', value: 'American Access Casualty Co.' },
    { id: 'American Alliance Casualty Co.', value: 'American Alliance Casualty Co.' },
    { id: 'American European', value: 'American European' },
    { id: 'American Family', value: 'American Family' },
    { id: 'American Farmers & Ranchers', value: 'American Farmers & Ranchers' },
    { id: 'American National Property & Casualty', value: 'American National Property & Casualty' },
    { id: 'American Risk Insurance Co.', value: 'American Risk Insurance Co.' },
    { id: 'American Sentinel Insurance Co', value: 'American Sentinel Insurance Co' },
    { id: 'American Traditions Ins Co.', value: 'American Traditions Ins Co.' },
    { id: 'Americas Insurance Company', value: 'Americas Insurance Company' },
    { id: 'Ameriprise', value: 'Ameriprise' },
    { id: 'AmeriTrust', value: 'AmeriTrust' },
    { id: 'Amica', value: 'Amica' },
    { id: 'Anchor Insurance', value: 'Anchor Insurance' },
    { id: 'Anchor Insurance Holdings Inc.', value: 'Anchor Insurance Holdings Inc.' },
    { id: 'Andover Companies', value: 'Andover Companies' },
    { id: 'Antilles Insurance Co.', value: 'Antilles Insurance Co.' },
    { id: 'Arbella Insurance', value: 'Arbella Insurance' },
    { id: 'Arch Insurance Co.', value: 'Arch Insurance Co.' },
    { id: 'Armed Forces Insurance', value: 'Armed Forces Insurance' },
    { id: 'ASI', value: 'ASI' },
    { id: 'Aspen', value: 'Aspen' },
    { id: 'Aspire General Insurance Co.', value: 'Aspire General Insurance Co.' },
    { id: 'Associated Mutual Ins Coop', value: 'Associated Mutual Ins Coop' },
    { id: 'AssuranceAmerica', value: 'AssuranceAmerica' },
    { id: 'Assurant', value: 'Assurant' },
    { id: 'Atlantic American / Delta Group', value: 'Atlantic American / Delta Group' },
    { id: 'Atlas Financial Holdings Inc.', value: 'Atlas Financial Holdings Inc.' },
    { id: 'Austin Mutual Insurance Co.', value: 'Austin Mutual Insurance Co.' },
    { id: 'Auto Club', value: 'Auto Club' },
    { id: 'Auto Club South Insurance Co.', value: 'Auto Club South Insurance Co.' },
    { id: 'Auto-Owners', value: 'Auto-Owners' },
    { id: 'Avatar P&C Insurance Co.', value: 'Avatar P&C Insurance Co.' },
    { id: 'Aventus Insurance Co.', value: 'Aventus Insurance Co.' },
    { id: 'AXIS', value: 'AXIS' },
    { id: 'Badger Mutual Insurance Co.', value: 'Badger Mutual Insurance Co.' },
    { id: 'Baldwin Mutual Insurance Co.', value: 'Baldwin Mutual Insurance Co.' },
    { id: 'Bank of America Corporation', value: 'Bank of America Corporation' },
    { id: 'Bankers Insurance', value: 'Bankers Insurance' },
    { id: 'Barnstable', value: 'Barnstable' },
    { id: 'Bear River Mutl Ins Co Inc', value: 'Bear River Mutl Ins Co Inc' },
    { id: 'Bedford Grange Mutual Ins Co.', value: 'Bedford Grange Mutual Ins Co.' },
    { id: 'Berkley Insurance Co.', value: 'Berkley Insurance Co.' },
    { id: 'Berkley Regional Insurance Co.', value: 'Berkley Regional Insurance Co.' },
    { id: 'BIC Holdings LLC', value: 'BIC Holdings LLC' },
    { id: 'BlueShore Insurance Co.', value: 'BlueShore Insurance Co.' },
    { id: 'Bremen Farmers Mutual Ins Co.', value: 'Bremen Farmers Mutual Ins Co.' },
    { id: 'Brethren Mutl Ins Co The', value: 'Brethren Mutl Ins Co The' },
    { id: 'Briar Creek Mutual Ins Co.', value: 'Briar Creek Mutual Ins Co.' },
    { id: 'Broome Co-operative Ins Co.', value: 'Broome Co-operative Ins Co.' },
    { id: 'Buckeye Insurance', value: 'Buckeye Insurance' },
    { id: 'Builders Mutual', value: 'Builders Mutual' },
    { id: 'Bunker Hill Insurance Co.', value: 'Bunker Hill Insurance Co.' },
    { id: 'California Casualty', value: 'California Casualty' },
    { id: 'California Mutual Insurance Co', value: 'California Mutual Insurance Co' },
    { id: 'Callicoon Co-operative Ins Co.', value: 'Callicoon Co-operative Ins Co.' },
    { id: 'Cameron Mutual', value: 'Cameron Mutual' },
    { id: 'Canopius US Insurance Inc.', value: 'Canopius US Insurance Inc.' },
    { id: 'Capital Insurance', value: 'Capital Insurance' },
    { id: 'Capitol Preferred Insurance Co', value: 'Capitol Preferred Insurance Co' },
    { id: 'Carolina Farmers Mutual Ins Co', value: 'Carolina Farmers Mutual Ins Co' },
    { id: 'Carolina Motor Club Inc.', value: 'Carolina Motor Club Inc.' },
    { id: 'Castle Key Insurance Co.', value: 'Castle Key Insurance Co.' },
    { id: 'Casualty Corp. of America Inc.', value: 'Casualty Corp. of America Inc.' },
    { id: 'Casualty Underwriters Ins Co.', value: 'Casualty Underwriters Ins Co.' },
    { id: 'Catalina Holdings (Bermuda) Ltd.', value: 'Catalina Holdings (Bermuda) Ltd.' },
    { id: 'Celina Insurance', value: 'Celina Insurance' },
    { id: 'CEM Insurance Co.', value: 'CEM Insurance Co.' },
    { id: 'Centauri Insurance', value: 'Centauri Insurance' },
    { id: 'Center Mutual Insurance Co.', value: 'Center Mutual Insurance Co.' },
    { id: 'Central Co-operative Ins Co.', value: 'Central Co-operative Ins Co.' },
    { id: 'Central Insurance Companies', value: 'Central Insurance Companies' },
    { id: 'Centre County Mutl Fire Ins Co', value: 'Centre County Mutl Fire Ins Co' },
    { id: 'Century Ins Co. (Guam) Ltd.', value: 'Century Ins Co. (Guam) Ltd.' },
    { id: 'Century Mutual Insurance Co.', value: 'Century Mutual Insurance Co.' },
    { id: 'Chautauqua Patrons Ins Co.', value: 'Chautauqua Patrons Ins Co.' },
    { id: 'Chubb', value: 'Chubb' },
    { id: 'Church Mutual', value: 'Church Mutual' },
    { id: 'Cincinnati Insurance', value: 'Cincinnati Insurance' },
    { id: 'Cities & Villages Mutl Ins Co.', value: 'Cities & Villages Mutl Ins Co.' },
    { id: 'Citizens Property Ins Corp.', value: 'Citizens Property Ins Corp.' },
    { id: 'Citizens United Recpl Exchange', value: 'Citizens United Recpl Exchange' },
    { id: 'Clarendon National Ins Co.', value: 'Clarendon National Ins Co.' },
    { id: 'Clear Blue Insurance', value: 'Clear Blue Insurance' },
    { id: 'CO Farm Bureau Mutual Ins Co.', value: 'CO Farm Bureau Mutual Ins Co.' },
    { id: 'Coastal American Insurance Co.', value: 'Coastal American Insurance Co.' },
    { id: 'Colonial', value: 'Colonial' },
    { id: 'Columbia Insurance', value: 'Columbia Insurance' },
    { id: 'Commonwealth Casualty Co.', value: 'Commonwealth Casualty Co.' },
    { id: 'Community Ins Co. (PA)', value: 'Community Ins Co. (PA)' },
    { id: 'Concord Group Insurance', value: 'Concord Group Insurance' },
    { id: 'Conifer Holdings Inc.', value: 'Conifer Holdings Inc.' },
    { id: 'Consumers County Mutual', value: 'Consumers County Mutual' },
    { id: 'Continental Corp.', value: 'Continental Corp.' },
    { id: 'Cooperativa de Seguros', value: 'Cooperativa de Seguros' },
    { id: 'Cornerstone National Ins Co.', value: 'Cornerstone National Ins Co.' },
    { id: 'COUNTRY Financial', value: 'COUNTRY Financial' },
    { id: 'Country-Wide Insurance Co.', value: 'Country-Wide Insurance Co.' },
    { id: 'Crestbrook Insurance Co.', value: 'Crestbrook Insurance Co.' },
    { id: 'Crum & Forster Holdings Corp.', value: 'Crum & Forster Holdings Corp.' },
    { id: 'CSAA', value: 'CSAA' },
    { id: 'CSE Insurance', value: 'CSE Insurance' },
    { id: 'Cumberland Group', value: 'Cumberland Group' },
    { id: 'Cypress Group Holdings, Inc.', value: 'Cypress Group Holdings, Inc.' },
    { id: 'DB Insurance Co. Ltd.', value: 'DB Insurance Co. Ltd.' },
    { id: 'De Smet Farm Mutl Ins Co of SD', value: 'De Smet Farm Mutl Ins Co of SD' },
    { id: 'Delaware Grange Mutual Ins Co.', value: 'Delaware Grange Mutual Ins Co.' },
    { id: 'Delta Lloyds Ins Co of Houston', value: 'Delta Lloyds Ins Co of Houston' },
    { id: 'Discovery Insurance Co.', value: 'Discovery Insurance Co.' },
    { id: 'Donegal Mutual Insurance Co.', value: 'Donegal Mutual Insurance Co.' },
    { id: 'Dryden Mutual Insurance Co.', value: 'Dryden Mutual Insurance Co.' },
    { id: 'DTRIC Insurance Co. Ltd.', value: 'DTRIC Insurance Co. Ltd.' },
    { id: 'Eagle Point Mutual Ins Co.', value: 'Eagle Point Mutual Ins Co.' },
    { id: 'ECM Insurance', value: 'ECM Insurance' },
    { id: 'Elephant Insurance Co.', value: 'Elephant Insurance Co.' },
    { id: 'Ellington Mutual Insurance Co.', value: 'Ellington Mutual Insurance Co.' },
    { id: 'EMC Insurance Group Inc.', value: 'EMC Insurance Group Inc.' },
    { id: 'EMC P&C Co.', value: 'EMC P&C Co.' },
    { id: 'Employers Mutual Casualty Co.', value: 'Employers Mutual Casualty Co.' },
    { id: 'Encompass', value: 'Encompass' },
    { id: 'Erie', value: 'Erie' },
    { id: 'Erie and Niagara Insurance', value: 'Erie and Niagara Insurance' },
    { id: 'Essentia Insurance Co.', value: 'Essentia Insurance Co.' },
    { id: 'Esurance', value: 'Esurance' },
    { id: 'Evanston Insurance Co.', value: 'Evanston Insurance Co.' },
    { id: 'Everest Re', value: 'Everest Re' },
    { id: 'Excalibur National Ins Co.', value: 'Excalibur National Ins Co.' },
    { id: 'Falcon Insurance Co.', value: 'Falcon Insurance Co.' },
    { id: 'Farm Bureau Financial Services', value: 'Farm Bureau Financial Services' },
    { id: 'Farm Bureau Mutl Ins Co Idaho', value: 'Farm Bureau Mutl Ins Co Idaho' },
    { id: 'Farm Bureau Mutl Ins Co. of AR', value: 'Farm Bureau Mutl Ins Co. of AR' },
    { id: 'Farm Crdt Sys Assn Captive Ins', value: 'Farm Crdt Sys Assn Captive Ins' },
    { id: 'Farm Family Insurance Companies', value: 'Farm Family Insurance Companies' },
    { id: 'Farmers', value: 'Farmers' },
    { id: 'Farmers & Mechanics Mutl Ins', value: 'Farmers & Mechanics Mutl Ins' },
    { id: 'Farmers & Mrchnt Mutl Fire Ins', value: 'Farmers & Mrchnt Mutl Fire Ins' },
    { id: 'Farmers Alliance Cos', value: 'Farmers Alliance Cos' },
    { id: 'Farmers and Mechanics', value: 'Farmers and Mechanics' },
    { id: 'Farmers Fire Insurance Co.', value: 'Farmers Fire Insurance Co.' },
    { id: 'Farmers Ins Co. of Flemington', value: 'Farmers Ins Co. of Flemington' },
    { id: 'Farmers Mutl Fire Ins Co Salem', value: 'Farmers Mutl Fire Ins Co Salem' },
    { id: 'Farmers Mutl Fire Ins Co. (OK)', value: 'Farmers Mutl Fire Ins Co. (OK)' },
    { id: 'Farmers Mutl Fire Marble PA', value: 'Farmers Mutl Fire Marble PA' },
    { id: 'Farmers Mutl Fire McCandless', value: 'Farmers Mutl Fire McCandless' },
    { id: 'Farmers Mutl Ins Co NE', value: 'Farmers Mutl Ins Co NE' },
    { id: 'Farmers Mutual Hail', value: 'Farmers Mutual Hail' },
    { id: 'Farmers Mutual Ins Co. (KS)', value: 'Farmers Mutual Ins Co. (KS)' },
    { id: 'Farmers Mutual Ins Co. (WV)', value: 'Farmers Mutual Ins Co. (WV)' },
    { id: 'Farmers Mutual Ins Co. of MI', value: 'Farmers Mutual Ins Co. of MI' },
    { id: 'Farmers Mutual of Tennessee', value: 'Farmers Mutual of Tennessee' },
    { id: 'Farmers Texas County Mutual', value: 'Farmers Texas County Mutual' },
    { id: 'Farmers Union Insurance', value: 'Farmers Union Insurance' },
    { id: 'Farmers Union Mutl Ins Co (MT)', value: 'Farmers Union Mutl Ins Co (MT)' },
    { id: 'Farmington Mutual Insurance Co', value: 'Farmington Mutual Insurance Co' },
    { id: 'FBAlliance Insurance', value: 'FBAlliance Insurance' },
    { id: 'Federated Insurance', value: 'Federated Insurance' },
    { id: 'FEDNAT', value: 'FEDNAT' },
    { id: 'Finger Lakes F&C Co.', value: 'Finger Lakes F&C Co.' },
    { id: "Fireman's Fund Insurance Co.", value: "Fireman's Fund Insurance Co." },
    { id: 'First Acceptance', value: 'First Acceptance' },
    { id: 'First American', value: 'First American' },
    { id: 'First Colonial Insurance Co.', value: 'First Colonial Insurance Co.' },
    { id: 'First Floridian Auto & Home', value: 'First Floridian Auto & Home' },
    { id: 'First Insurance Co. of HI Ltd.', value: 'First Insurance Co. of HI Ltd.' },
    { id: 'First Mercury SNL Subgroup', value: 'First Mercury SNL Subgroup' },
    { id: 'First Mutual Insurance Co.', value: 'First Mutual Insurance Co.' },
    { id: 'First Net Insurance Co.', value: 'First Net Insurance Co.' },
    { id: 'First Protective Insurance Co.', value: 'First Protective Insurance Co.' },
    { id: 'Florida Family Insurance', value: 'Florida Family Insurance' },
    { id: 'Florida Farm Bureau', value: 'Florida Farm Bureau' },
    { id: 'Florida Peninsula Holdings LLC', value: 'Florida Peninsula Holdings LLC' },
    { id: 'Florida Specialty Insurance Co', value: 'Florida Specialty Insurance Co' },
    { id: 'FM Global', value: 'FM Global' },
    { id: 'Foremost', value: 'Foremost' },
    { id: 'Foremost County Mutual Ins Co.', value: 'Foremost County Mutual Ins Co.' },
    { id: 'Foremost Lloyds of Texas', value: 'Foremost Lloyds of Texas' },
    { id: 'Founders Insurance Co.', value: 'Founders Insurance Co.' },
    { id: 'Frankenmuth Insurance', value: 'Frankenmuth Insurance' },
    { id: 'Franklin Mutual', value: 'Franklin Mutual' },
    { id: 'Frederick Mutual Insurance Co.', value: 'Frederick Mutual Insurance Co.' },
    { id: 'Friends Cove Mutual Ins Co.', value: 'Friends Cove Mutual Ins Co.' },
    { id: 'Frontier - Mt Carroll Mutl Ins', value: 'Frontier - Mt Carroll Mutl Ins' },
    { id: 'Fulmont Mutual Insurance Co.', value: 'Fulmont Mutual Insurance Co.' },
    { id: 'GEICO', value: 'GEICO' },
    { id: 'Gem State Insurance Co.', value: 'Gem State Insurance Co.' },
    { id: 'General Electric Co.', value: 'General Electric Co.' },
    { id: 'General Insurance', value: 'General Insurance' },
    { id: 'General Star Companies', value: 'General Star Companies' },
    { id: 'Generali U.S. Branch', value: 'Generali U.S. Branch' },
    { id: 'Genesee Patrons Coop Ins Co.', value: 'Genesee Patrons Coop Ins Co.' },
    { id: 'Geneva Insurance Co.', value: 'Geneva Insurance Co.' },
    { id: 'Georgia Farm Bureau', value: 'Georgia Farm Bureau' },
    { id: 'GeoVera Holdings', value: 'GeoVera Holdings' },
    { id: 'Germania Insurance', value: 'Germania Insurance' },
    { id: 'Germantown Mutual Insurance Co', value: 'Germantown Mutual Insurance Co' },
    { id: 'Global Indemnity', value: 'Global Indemnity' },
    { id: 'GNW Holding Inc.', value: 'GNW Holding Inc.' },
    { id: 'GNY Insurance Companies', value: 'GNY Insurance Companies' },
    { id: 'GoAuto Insurance Co.', value: 'GoAuto Insurance Co.' },
    { id: 'Golden Bear Insurance Co.', value: 'Golden Bear Insurance Co.' },
    { id: 'Goodville & German Mutual Group', value: 'Goodville & German Mutual Group' },
    { id: 'Grange', value: 'Grange' },
    { id: 'Grange Insurance Assn.', value: 'Grange Insurance Assn.' },
    { id: 'Grange Mutual Fire Ins Co.', value: 'Grange Mutual Fire Ins Co.' },
    { id: 'Great American Insurance Co.', value: 'Great American Insurance Co.' },
    { id: 'Great Lakes Mutual Ins Co.', value: 'Great Lakes Mutual Ins Co.' },
    { id: 'Greenville Casualty Ins Co.', value: 'Greenville Casualty Ins Co.' },
    { id: 'Grinnell Mutual', value: 'Grinnell Mutual' },
    { id: 'Growers Automobile Ins Assn.', value: 'Growers Automobile Ins Assn.' },
    { id: 'GUARD Insurance Companies', value: 'GUARD Insurance Companies' },
    { id: 'GuideOne Insurance', value: 'GuideOne Insurance' },
    { id: 'Gulf States Ins Co. (LA)', value: 'Gulf States Ins Co. (LA)' },
    { id: 'Gulfstream P&C Insurance Co.', value: 'Gulfstream P&C Insurance Co.' },
    { id: 'Halifax Mutual Insurance Co.', value: 'Halifax Mutual Insurance Co.' },
    { id: 'Hallmark', value: 'Hallmark' },
    { id: 'Hamilton Mutual Insurance Co.', value: 'Hamilton Mutual Insurance Co.' },
    { id: 'Hanover Fire & Casualty Ins Co', value: 'Hanover Fire & Casualty Ins Co' },
    { id: 'Harbor Insurance Co.', value: 'Harbor Insurance Co.' },
    { id: 'Harford Mutual', value: 'Harford Mutual' },
    { id: 'Harleysville Insurance', value: 'Harleysville Insurance' },
    { id: 'Hartford', value: 'Hartford' },
    { id: 'Hastings Mutual Insurance Co.', value: 'Hastings Mutual Insurance Co.' },
    { id: 'HCI Group, Inc.', value: 'HCI Group, Inc.' },
    { id: 'Heritage Insurance', value: 'Heritage Insurance' },
    { id: 'Hochheim Prairie Insurance', value: 'Hochheim Prairie Insurance' },
    { id: 'Home State Insurance Group', value: 'Home State Insurance Group' },
    { id: 'Homeowners of America Ins Co.', value: 'Homeowners of America Ins Co.' },
    { id: 'Homesite', value: 'Homesite' },
    { id: 'Horace Mann', value: 'Horace Mann' },
    { id: 'Houston International Insurance', value: 'Houston International Insurance' },
    { id: 'Hyundai Marine & Fire Ins Co.', value: 'Hyundai Marine & Fire Ins Co.' },
    { id: 'IAT Insurance Grp Inc.', value: 'IAT Insurance Grp Inc.' },
    { id: 'ICW', value: 'ICW' },
    { id: 'IMT', value: 'IMT' },
    { id: 'IN Farmers Mutl Ins Co', value: 'IN Farmers Mutl Ins Co' },
    { id: 'Independent Mutual Fire Ins Co', value: 'Independent Mutual Fire Ins Co' },
    { id: 'Indiana Farm Bureau', value: 'Indiana Farm Bureau' },
    { id: 'Infinity', value: 'Infinity' },
    { id: 'Inland Mutual Insurance Co.', value: 'Inland Mutual Insurance Co.' },
    { id: 'Integon', value: 'Integon' },
    { id: 'INTEGRAND Assurance Co.', value: 'INTEGRAND Assurance Co.' },
    { id: 'Ironshore Holdings (U.S.) Inc.', value: 'Ironshore Holdings (U.S.) Inc.' },
    { id: 'Island Home Insurance Co.', value: 'Island Home Insurance Co.' },
    { id: 'Island Insurance Companies', value: 'Island Insurance Companies' },
    { id: 'Jefferson Insurance Co.', value: 'Jefferson Insurance Co.' },
    { id: 'Juniata Mutual Insurance Co.', value: 'Juniata Mutual Insurance Co.' },
    { id: 'Kansas Mutual Insurance Co.', value: 'Kansas Mutual Insurance Co.' },
    { id: 'Kemper Direct', value: 'Kemper Direct' },
    { id: 'Kemper Insurance', value: 'Kemper Insurance' },
    { id: 'Kemper Specialty Insurance', value: 'Kemper Specialty Insurance' },
    { id: 'Kensington Insurance Co.', value: 'Kensington Insurance Co.' },
    { id: 'Kentucky Farm Bureau', value: 'Kentucky Farm Bureau' },
    { id: 'Kentucky Growers Insurance Co.', value: 'Kentucky Growers Insurance Co.' },
    { id: 'Kentucky National Insurance Co', value: 'Kentucky National Insurance Co' },
    { id: 'Key Insurance Co.', value: 'Key Insurance Co.' },
    { id: 'Kingstone Insurance Co.', value: 'Kingstone Insurance Co.' },
    { id: 'Kinsale Insurance Co.', value: 'Kinsale Insurance Co.' },
    { id: 'Knight Insurance', value: 'Knight Insurance' },
    { id: 'LA Citizens Ppty Ins Corp.', value: 'LA Citizens Ppty Ins Corp.' },
    { id: 'LA Farm Bureau Mutual Ins Co.', value: 'LA Farm Bureau Mutual Ins Co.' },
    { id: 'Leatherstocking Coop Ins Co.', value: 'Leatherstocking Coop Ins Co.' },
    { id: 'Lemonade Insurance Co.', value: 'Lemonade Insurance Co.' },
    { id: 'Liberty County Mutual', value: 'Liberty County Mutual' },
    { id: 'Liberty Mutual', value: 'Liberty Mutual' },
    { id: 'Lighthouse Property Ins Corp.', value: 'Lighthouse Property Ins Corp.' },
    { id: 'Lititz Mutual', value: 'Lititz Mutual' },
    { id: 'Little Black Mutual Ins Co.', value: 'Little Black Mutual Ins Co.' },
    { id: 'Lockhart Companies Inc.', value: 'Lockhart Companies Inc.' },
    { id: 'Loudoun Mutual Insurance Co.', value: 'Loudoun Mutual Insurance Co.' },
    { id: 'Loya Insurance', value: 'Loya Insurance' },
    { id: 'Lutheran Mutual Fire Ins Co.', value: 'Lutheran Mutual Fire Ins Co.' },
    { id: 'Madison Mutual Ins Co. (IL)', value: 'Madison Mutual Ins Co. (IL)' },
    { id: 'Madison Mutual Ins Co. (NY)', value: 'Madison Mutual Ins Co. (NY)' },
    { id: 'Maidstone Insurance Co.', value: 'Maidstone Insurance Co.' },
    { id: 'Maison Insurance Co.', value: 'Maison Insurance Co.' },
    { id: 'MAPFRE', value: 'MAPFRE' },
    { id: 'Mapfre Praico Corp.', value: 'Mapfre Praico Corp.' },
    { id: 'Maple Valley Mutual Ins Co.', value: 'Maple Valley Mutual Ins Co.' },
    { id: 'Markel American Insurance Co.', value: 'Markel American Insurance Co.' },
    { id: 'Markel Insurance Co.', value: 'Markel Insurance Co.' },
    { id: 'Maryland Automobile Ins Fund', value: 'Maryland Automobile Ins Fund' },
    { id: 'Marysville Mutual Insurance Co', value: 'Marysville Mutual Insurance Co' },
    { id: 'McMillan-Warner Mutual Ins Co.', value: 'McMillan-Warner Mutual Ins Co.' },
    { id: 'Mennonite Mutual Insurance Co.', value: 'Mennonite Mutual Insurance Co.' },
    { id: 'Merchants Insurance', value: 'Merchants Insurance' },
    { id: 'Mercury', value: 'Mercury' },
    { id: 'Metlife', value: 'Metlife' },
    { id: 'Metromile Insurance Co.', value: 'Metromile Insurance Co.' },
    { id: 'MFS Mutual Insurance Co.', value: 'MFS Mutual Insurance Co.' },
    { id: 'MGA Insurance Co.', value: 'MGA Insurance Co.' },
    { id: 'MI Automobile Ins Placement', value: 'MI Automobile Ins Placement' },
    { id: 'MI Basic Property Ins Assn.', value: 'MI Basic Property Ins Assn.' },
    { id: 'Michigan Farm Bureau', value: 'Michigan Farm Bureau' },
    { id: 'Michigan Insurance Co.', value: 'Michigan Insurance Co.' },
    { id: 'Mid-Hudson Co-Operative Ins Co', value: 'Mid-Hudson Co-Operative Ins Co' },
    { id: 'Midrox Insurance Co.', value: 'Midrox Insurance Co.' },
    { id: 'Midstate Mutual Insurance Co.', value: 'Midstate Mutual Insurance Co.' },
    { id: 'Midwest Family', value: 'Midwest Family' },
    { id: 'Millville Mutual', value: 'Millville Mutual' },
    { id: 'Missouri Farm Bureau Insurance', value: 'Missouri Farm Bureau Insurance' },
    { id: 'Missouri Valley Mutual Ins Co.', value: 'Missouri Valley Mutual Ins Co.' },
    { id: 'MMG Insurance Co.', value: 'MMG Insurance Co.' },
    { id: 'Modern USA Insurance Co.', value: 'Modern USA Insurance Co.' },
    { id: 'Montgomery Mutual Insurance Co', value: 'Montgomery Mutual Insurance Co' },
    { id: 'Montour Mutual Insurance Co.', value: 'Montour Mutual Insurance Co.' },
    { id: 'Motorists Insurance Group', value: 'Motorists Insurance Group' },
    { id: 'Motors Insurance Corporation', value: 'Motors Insurance Corporation' },
    { id: 'MS Farm Bureau Casualty Ins Co', value: 'MS Farm Bureau Casualty Ins Co' },
    { id: 'Mt. Morris Mutual Insurance Co', value: 'Mt. Morris Mutual Insurance Co' },
    { id: 'Mtn W Farm Bureau Mutl Ins Co.', value: 'Mtn W Farm Bureau Mutl Ins Co.' },
    { id: 'Multinational Insurance Co.', value: 'Multinational Insurance Co.' },
    { id: 'Munich Re America Corp.', value: 'Munich Re America Corp.' },
    { id: 'Municipal Mutual Ins Co. of WV', value: 'Municipal Mutual Ins Co. of WV' },
    { id: 'Mutual Benefit', value: 'Mutual Benefit' },
    { id: 'Mutual of Enumclaw', value: 'Mutual of Enumclaw' },
    { id: 'Mutual of Wausau', value: 'Mutual of Wausau' },
    { id: 'Mutual Savings Fire Ins Co.', value: 'Mutual Savings Fire Ins Co.' },
    { id: 'MutualAid eXchange', value: 'MutualAid eXchange' },
    { id: 'National Direct Insurance Co.', value: 'National Direct Insurance Co.' },
    { id: 'National General', value: 'National General' },
    { id: 'National Heritage Insurance Co', value: 'National Heritage Insurance Co' },
    { id: 'National Indemnity', value: 'National Indemnity' },
    { id: 'National Interstate Corp.', value: 'National Interstate Corp.' },
    { id: 'National Lloyds Corporation', value: 'National Lloyds Corporation' },
    { id: 'National Security Group Inc.', value: 'National Security Group Inc.' },
    { id: 'National Unity Insurance Co.', value: 'National Unity Insurance Co.' },
    { id: 'Nations Insurance Co.', value: 'Nations Insurance Co.' },
    { id: 'Nationwide', value: 'Nationwide' },
    { id: 'Nationwide E&S/Specialty', value: 'Nationwide E&S/Specialty' },
    { id: 'Nationwide Insurance Co. of FL', value: 'Nationwide Insurance Co. of FL' },
    { id: 'Nazareth Mutual Insurance Co.', value: 'Nazareth Mutual Insurance Co.' },
    { id: 'NBIC Holdings Inc.', value: 'NBIC Holdings Inc.' },
    { id: 'NC Grange Mutual Ins Co.', value: 'NC Grange Mutual Ins Co.' },
    { id: 'New London County Mutl Ins Co.', value: 'New London County Mutl Ins Co.' },
    { id: 'NGM Insurance Co.', value: 'NGM Insurance Co.' },
    { id: 'NJM', value: 'NJM' },
    { id: 'Nodak Mutual Group Inc.', value: 'Nodak Mutual Group Inc.' },
    { id: 'Norfolk & Dedham Group', value: 'Norfolk & Dedham Group' },
    { id: 'North Carolina Farm Bureau', value: 'North Carolina Farm Bureau' },
    { id: 'North Country Insurance Co.', value: 'North Country Insurance Co.' },
    { id: 'North Light Specialty Ins Co.', value: 'North Light Specialty Ins Co.' },
    { id: 'North Star Mutl Ins Co', value: 'North Star Mutl Ins Co' },
    { id: 'Northern Mutual Insurance Co.', value: 'Northern Mutual Insurance Co.' },
    { id: 'Northern Neck Insurance Co.', value: 'Northern Neck Insurance Co.' },
    { id: 'Northwest G.F. Mutual Ins Co.', value: 'Northwest G.F. Mutual Ins Co.' },
    { id: 'NW Farmers Mutual Insurance Co', value: 'NW Farmers Mutual Insurance Co' },
    { id: 'NYCM Insurance', value: 'NYCM Insurance' },
    { id: 'Odyssey Re Holdings Corp.', value: 'Odyssey Re Holdings Corp.' },
    { id: 'Ohio FAIR Plan Undrwtg Assn.', value: 'Ohio FAIR Plan Undrwtg Assn.' },
    { id: 'Ohio Mutual Insurance Group', value: 'Ohio Mutual Insurance Group' },
    { id: 'Oklahoma Farm Bureau Insurance', value: 'Oklahoma Farm Bureau Insurance' },
    { id: 'Old American', value: 'Old American' },
    { id: 'Old Reliable Casualty Co.', value: 'Old Reliable Casualty Co.' },
    { id: 'Old Repub General Ins Grp Inc.', value: 'Old Repub General Ins Grp Inc.' },
    { id: 'Olympus Insurance Co.', value: 'Olympus Insurance Co.' },
    { id: 'One Alliance Insurance Corp.', value: 'One Alliance Insurance Corp.' },
    { id: 'Ontario Insurance Co.', value: 'Ontario Insurance Co.' },
    { id: 'Oregon Mutual', value: 'Oregon Mutual' },
    { id: 'Oswego County Mutual Ins Co.', value: 'Oswego County Mutual Ins Co.' },
    { id: 'Otsego Cnty Patrons Co-Op Fire', value: 'Otsego Cnty Patrons Co-Op Fire' },
    { id: 'Otsego Mutual Fire Ins Co.', value: 'Otsego Mutual Fire Ins Co.' },
    { id: 'Pacific Indemnity Insurance Co', value: 'Pacific Indemnity Insurance Co' },
    { id: 'Pacific Pioneer Insurance Co.', value: 'Pacific Pioneer Insurance Co.' },
    { id: 'Pacific Specialty Insurance Company', value: 'Pacific Specialty Insurance Company' },
    { id: 'Palmetto Casualty Insurance Co', value: 'Palmetto Casualty Insurance Co' },
    { id: 'Palomar Spclty Ins Co', value: 'Palomar Spclty Ins Co' },
    { id: 'Panhandle Farmers Mutl Ins Co', value: 'Panhandle Farmers Mutl Ins Co' },
    { id: 'Paramount Insurance Co.', value: 'Paramount Insurance Co.' },
    { id: 'PartnerRe', value: 'PartnerRe' },
    { id: 'Patrons Co-op Fire Ins Co.', value: 'Patrons Co-op Fire Ins Co.' },
    { id: 'Patrons Mutual Fire Ins Co.', value: 'Patrons Mutual Fire Ins Co.' },
    { id: 'Peachtree Casualty Ins Co.', value: 'Peachtree Casualty Ins Co.' },
    { id: 'Pekin Insurance', value: 'Pekin Insurance' },
    { id: 'PEMCO Mutual Insurance Co.', value: 'PEMCO Mutual Insurance Co.' },
    { id: 'Peninsula Insurance Co.', value: 'Peninsula Insurance Co.' },
    { id: 'Penn National Insurance', value: 'Penn National Insurance' },
    { id: 'Penn-America Group Inc.', value: 'Penn-America Group Inc.' },
    { id: 'Pennsylvania Lumbermens Mutual', value: 'Pennsylvania Lumbermens Mutual' },
    { id: "People's Trust Insurance Co.", value: "People's Trust Insurance Co." },
    { id: 'Pharmacists Mutual', value: 'Pharmacists Mutual' },
    { id: 'Philadelphia Contributionship', value: 'Philadelphia Contributionship' },
    { id: 'Philadelphia Insurance Companies', value: 'Philadelphia Insurance Companies' },
    { id: 'Piedmont Mutual Insurance Co.', value: 'Piedmont Mutual Insurance Co.' },
    { id: 'Pioneer State Mutual Ins Co.', value: 'Pioneer State Mutual Ins Co.' },
    { id: 'Plymouth Rock', value: 'Plymouth Rock' },
    { id: 'Plymouth Rock Assurance', value: 'Plymouth Rock Assurance' },
    { id: 'Praetorian Insurance Co.', value: 'Praetorian Insurance Co.' },
    { id: 'Preferred Auto Insurance Co.', value: 'Preferred Auto Insurance Co.' },
    { id: 'Preferred Mutual Insurance Co.', value: 'Preferred Mutual Insurance Co.' },
    { id: 'Premier Holdings LLC', value: 'Premier Holdings LLC' },
    { id: 'Premier Insurance Co. of MA', value: 'Premier Insurance Co. of MA' },
    { id: 'Prepared Insurance Co.', value: 'Prepared Insurance Co.' },
    { id: 'Prime Insurance', value: 'Prime Insurance' },
    { id: "Producer's National Corp.", value: "Producer's National Corp." },
    { id: 'Progressive', value: 'Progressive' },
    { id: 'Protective Insurance Corp.', value: 'Protective Insurance Corp.' },
    { id: 'Providence Mutual Fire Ins Co.', value: 'Providence Mutual Fire Ins Co.' },
    { id: 'PURE', value: 'PURE' },
    { id: 'QBE Regional Cos. (N.A.)', value: 'QBE Regional Cos. (N.A.)' },
    { id: 'QBE Reinsurance Corporation', value: 'QBE Reinsurance Corporation' },
    { id: 'QBE Seguros', value: 'QBE Seguros' },
    { id: 'Qualitas Insurance Co.', value: 'Qualitas Insurance Co.' },
    { id: 'Quincy Mutual', value: 'Quincy Mutual' },
    { id: 'RAM Mutual Insurance Co.', value: 'RAM Mutual Insurance Co.' },
    { id: 'Real Legacy Assurance Co.', value: 'Real Legacy Assurance Co.' },
    { id: 'Reamstown Mutual Insurance Co.', value: 'Reamstown Mutual Insurance Co.' },
    { id: 'Redpoint County Mutual Ins Co.', value: 'Redpoint County Mutual Ins Co.' },
    { id: 'Repub Fire & Casualty Ins Co.', value: 'Repub Fire & Casualty Ins Co.' },
    { id: 'Repub Lloyds', value: 'Repub Lloyds' },
    { id: 'Republic Underwriters Ins Co.', value: 'Republic Underwriters Ins Co.' },
    { id: 'Republic-Vanguard Insurance Co', value: 'Republic-Vanguard Insurance Co' },
    { id: 'Responsive Auto Insurance Co.', value: 'Responsive Auto Insurance Co.' },
    { id: 'RFH Special Purpose I LLC', value: 'RFH Special Purpose I LLC' },
    { id: 'Rider Insurance Co.', value: 'Rider Insurance Co.' },
    { id: 'RLI', value: 'RLI' },
    { id: 'Rockford Mutual Insurance Co.', value: 'Rockford Mutual Insurance Co.' },
    { id: 'Rockhill Insurance', value: 'Rockhill Insurance' },
    { id: 'Rockingham Insurance', value: 'Rockingham Insurance' },
    { id: 'Root Insurance Co.', value: 'Root Insurance Co.' },
    { id: 'Rural Mutual Insurance Co.', value: 'Rural Mutual Insurance Co.' },
    { id: 'RVOS Insurance', value: 'RVOS Insurance' },
    { id: 'Safe Auto Insurance Co.', value: 'Safe Auto Insurance Co.' },
    { id: 'Safe Harbor Insurance Co.', value: 'Safe Harbor Insurance Co.' },
    { id: 'Safe Insurance Co.', value: 'Safe Insurance Co.' },
    { id: 'Safepoint Insurance Co.', value: 'Safepoint Insurance Co.' },
    { id: 'Safety Insurance', value: 'Safety Insurance' },
    { id: 'Safeway Insurance', value: 'Safeway Insurance' },
    { id: 'Saucon Insurance Co.', value: 'Saucon Insurance Co.' },
    { id: 'Sauquoit Valley Insurance Co.', value: 'Sauquoit Valley Insurance Co.' },
    { id: 'Sawgrass Mutual Insurance Co.', value: 'Sawgrass Mutual Insurance Co.' },
    { id: 'SC Farm Bureau Insurance Co.', value: 'SC Farm Bureau Insurance Co.' },
    { id: 'SC Farm Bureau Mutual Ins Co.', value: 'SC Farm Bureau Mutual Ins Co.' },
    { id: 'SCOR', value: 'SCOR' },
    { id: 'SECURA Insurance Companies', value: 'SECURA Insurance Companies' },
    { id: 'Security First Insurance Co.', value: 'Security First Insurance Co.' },
    { id: 'Security Mutual Insurance Co.', value: 'Security Mutual Insurance Co.' },
    { id: 'Selective', value: 'Selective' },
    { id: 'Sentry', value: 'Sentry' },
    { id: 'Service Insurance Co (FL)', value: 'Service Insurance Co (FL)' },
    { id: 'Shelter', value: 'Shelter' },
    { id: 'Sirius', value: 'Sirius' },
    { id: 'Sompo', value: 'Sompo' },
    { id: 'Southern County Mutual Ins Co.', value: 'Southern County Mutual Ins Co.' },
    { id: 'Southern Fidelity Insurance Co', value: 'Southern Fidelity Insurance Co' },
    { id: 'Southern Fidelity P&C Inc.', value: 'Southern Fidelity P&C Inc.' },
    { id: 'Southern General Insurance Co.', value: 'Southern General Insurance Co.' },
    { id: 'Southern Insurance Co.', value: 'Southern Insurance Co.' },
    { id: 'Southern Oak Insurance Co.', value: 'Southern Oak Insurance Co.' },
    { id: 'Southern Pioneer P&C Ins Co.', value: 'Southern Pioneer P&C Ins Co.' },
    { id: 'Southern Trust Insurance Co.', value: 'Southern Trust Insurance Co.' },
    { id: 'Southern Underwriters Ins Co.', value: 'Southern Underwriters Ins Co.' },
    { id: 'Southern Vanguard Insurance Co', value: 'Southern Vanguard Insurance Co' },
    { id: 'Southwest General Insurance Co', value: 'Southwest General Insurance Co' },
    { id: 'Spartan Insurance Co.', value: 'Spartan Insurance Co.' },
    { id: 'Spinnaker Insurance Co.', value: 'Spinnaker Insurance Co.' },
    { id: 'St. Johns Insurance Co.', value: 'St. Johns Insurance Co.' },
    { id: 'St. Paul Fire & Marine Ins Co.', value: 'St. Paul Fire & Marine Ins Co.' },
    { id: 'Standard Casualty Co.', value: 'Standard Casualty Co.' },
    { id: 'Star & Shield Ins Exchange', value: 'Star & Shield Ins Exchange' },
    { id: 'Star Casualty Insurance Co.', value: 'Star Casualty Insurance Co.' },
    { id: 'STARR Cos.', value: 'STARR Cos.' },
    { id: 'StarStone Ins Bermuda Ltd.', value: 'StarStone Ins Bermuda Ltd.' },
    { id: 'State Auto', value: 'State Auto' },
    { id: 'State Farm', value: 'State Farm' },
    { id: 'State National Companies Inc.', value: 'State National Companies Inc.' },
    { id: 'Sterling Casualty Insurance Co', value: 'Sterling Casualty Insurance Co' },
    { id: 'Sterling Insurance Co.', value: 'Sterling Insurance Co.' },
    { id: 'Sthrn Farm Bureau Cas Ins Co', value: 'Sthrn Farm Bureau Cas Ins Co' },
    { id: 'Stillwater Insurance Co.', value: 'Stillwater Insurance Co.' },
    { id: 'Sutter Insurance Co.', value: 'Sutter Insurance Co.' },
    { id: 'Tennessee Farmers Insurance', value: 'Tennessee Farmers Insurance' },
    { id: 'Texas FAIR Plan Association', value: 'Texas FAIR Plan Association' },
    { id: 'Texas Farm Bureau', value: 'Texas Farm Bureau' },
    { id: 'The Doctors Co.', value: 'The Doctors Co.' },
    { id: 'The Hanover', value: 'The Hanover' },
    { id: 'Tiptree Inc.', value: 'Tiptree Inc.' },
    { id: 'Titan Indemnity Co.', value: 'Titan Indemnity Co.' },
    { id: 'Tokio Marine & Nichido Fire', value: 'Tokio Marine & Nichido Fire' },
    { id: 'Topa Insurance', value: 'Topa Insurance' },
    { id: 'Tower Hill', value: 'Tower Hill' },
    { id: 'Traders Insurance Co.', value: 'Traders Insurance Co.' },
    { id: 'Travelers', value: 'Travelers' },
    { id: 'Triple-S Propiedad Inc.', value: 'Triple-S Propiedad Inc.' },
    { id: 'Tri-State Consumer Ins Co.', value: 'Tri-State Consumer Ins Co.' },
    { id: 'Triton Insurance Co.', value: 'Triton Insurance Co.' },
    { id: 'Tuscarora Wayne Mutual Grp Inc', value: 'Tuscarora Wayne Mutual Grp Inc' },
    { id: 'U.S. Investment Corp.', value: 'U.S. Investment Corp.' },
    { id: "Underwriters at Lloyd's (VI)", value: "Underwriters at Lloyd's (VI)" },
    { id: 'Union Ins Co. of Providence', value: 'Union Ins Co. of Providence' },
    { id: 'Union Mutual', value: 'Union Mutual' },
    { id: 'Union Mutual Insurance Co.', value: 'Union Mutual Insurance Co.' },
    { id: 'United Casualty Ins Co. of Am', value: 'United Casualty Ins Co. of Am' },
    { id: 'United Equitable Group Ltd.', value: 'United Equitable Group Ltd.' },
    { id: 'United Fire Group Inc.', value: 'United Fire Group Inc.' },
    { id: 'United Frontier Mutual Ins Co.', value: 'United Frontier Mutual Ins Co.' },
    { id: 'United Heritage Insurance', value: 'United Heritage Insurance' },
    { id: 'United Home Insurance Co.', value: 'United Home Insurance Co.' },
    { id: 'United Insurance Co.', value: 'United Insurance Co.' },
    { id: 'United National Insurance Co.', value: 'United National Insurance Co.' },
    { id: 'Univ Ins Co. of North America', value: 'Univ Ins Co. of North America' },
    { id: 'Universal Insurance', value: 'Universal Insurance' },
    { id: 'Universal Insurance Co (PR)', value: 'Universal Insurance Co (PR)' },
    { id: 'Universal North America Ins Co', value: 'Universal North America Ins Co' },
    { id: 'Untd Automobile Ins Co', value: 'Untd Automobile Ins Co' },
    { id: 'UPC Insurance', value: 'UPC Insurance' },
    { id: 'Upland Mutual Insurance Inc.', value: 'Upland Mutual Insurance Inc.' },
    { id: 'US Coastal', value: 'US Coastal' },
    { id: 'US Lloyds Insurance Co.', value: 'US Lloyds Insurance Co.' },
    { id: 'USA Insurance Co.', value: 'USA Insurance Co.' },
    { id: 'USA Underwriters', value: 'USA Underwriters' },
    { id: 'USAA', value: 'USAA' },
    { id: 'Utica First Insurance Co. Inc', value: 'Utica First Insurance Co. Inc' },
    { id: 'Utica Mutual Insurance Co.', value: 'Utica Mutual Insurance Co.' },
    { id: 'VA Farm Bureau Federation', value: 'VA Farm Bureau Federation' },
    { id: 'Vault Reciprocal Exchange', value: 'Vault Reciprocal Exchange' },
    { id: 'Vermont Mutual Insurance', value: 'Vermont Mutual Insurance' },
    { id: 'Victoria Insurance', value: 'Victoria Insurance' },
    { id: 'W L Dunn Group', value: 'W L Dunn Group' },
    { id: 'Wall Rose Mutual Insurance Co.', value: 'Wall Rose Mutual Insurance Co.' },
    { id: 'Warrior Invictus Holding Co.', value: 'Warrior Invictus Holding Co.' },
    { id: 'Washington County Coop Ins Co', value: 'Washington County Coop Ins Co' },
    { id: 'Wawanesa General Insurance Co.', value: 'Wawanesa General Insurance Co.' },
    { id: 'Wayne Cooperative Insurance Co', value: 'Wayne Cooperative Insurance Co' },
    { id: 'Wayne Mutual Insurance Co.', value: 'Wayne Mutual Insurance Co.' },
    { id: 'WEA P&C Insurance Co.', value: 'WEA P&C Insurance Co.' },
    { id: 'West Bend Mutual Insurance Co.', value: 'West Bend Mutual Insurance Co.' },
    { id: 'West Branch Mutl Insurance Co.', value: 'West Branch Mutl Insurance Co.' },
    { id: 'West Virginia Insurance Co.', value: 'West Virginia Insurance Co.' },
    { id: 'West Virginia Natl Auto Ins Co', value: 'West Virginia Natl Auto Ins Co' },
    { id: 'Western General Insurance Co.', value: 'Western General Insurance Co.' },
    { id: 'Western Mutual Insurance', value: 'Western Mutual Insurance' },
    { id: 'Western National Insurance', value: 'Western National Insurance' },
    { id: 'Western Reserve Group', value: 'Western Reserve Group' },
    { id: 'Western Select Insurance Co.', value: 'Western Select Insurance Co.' },
    { id: 'Western World', value: 'Western World' },
    { id: 'Westfield Insurance', value: 'Westfield Insurance' },
    { id: 'WI Mutl Ins Co', value: 'WI Mutl Ins Co' },
    { id: 'Wilmington Insurance Co.', value: 'Wilmington Insurance Co.' },
    { id: 'Windhaven Insurance Co.', value: 'Windhaven Insurance Co.' },
    { id: 'Windhaven National Ins Co.', value: 'Windhaven National Ins Co.' },
    { id: 'Windsor Mount Joy Mutual Insurance Co.', value: 'Windsor Mount Joy Mutual Insurance Co.' },
    { id: 'Wisconsin Reinsurance Corp.', value: 'Wisconsin Reinsurance Corp.' },
    { id: 'Wolverine Mutual Insurance Co.', value: 'Wolverine Mutual Insurance Co.' },
    { id: 'Woodlands Insurance Co.', value: 'Woodlands Insurance Co.' },
    { id: 'XL Group', value: 'XL Group' },
    { id: 'Yosemite Insurance Co.', value: 'Yosemite Insurance Co.' },
    { id: 'Zurich American Insurance Co.', value: 'Zurich American Insurance Co.' }
];
exports.insuranceProviderContact = [
    {
        priorCompany: '21st Century Insurance',
        email1: 'service@21st.com',
        email2: '',
        fax1: '800-842-3057',
        fax2: '800-842-3057',
        fax3: '866-447-2611',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'AAA',
        email1: 'correspondence@acg.aaa.com',
        email2: '',
        fax1: '877-489-5696',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: true,
        MailingAddress: '',
        Phone: '877-387-8378',
        specialInstructions: 'to get email of regional office'
    },
    {
        priorCompany: 'AAA Texas',
        email1: '',
        email2: '',
        fax1: '714-754-4759',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: true,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Absolute Insurance Solutions',
        email1: 'info@aisiteam.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Acadia Insurance',
        email1: '',
        email2: '',
        fax1: '207-772-6104',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Acceptance Casualty Insurance',
        email1: '',
        email2: '',
        fax1: '402-342-0096',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Access General',
        email1: '',
        email2: '',
        fax1: '770-234-3738',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '877-353-9838',
        specialInstructions: ''
    },
    {
        priorCompany: 'Access Home Insurance Co',
        email1: '',
        email2: '',
        fax1: '225-246-2167',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Accident Fund Insurance',
        email1: '',
        email2: '',
        fax1: '517-367-2925',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Acuity',
        email1: '',
        email2: '',
        fax1: '920-458-1618',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Addison Insurance Company',
        email1: 'doingbusiness@unitedfiregroup.com',
        email2: '',
        fax1: '319-286-2512',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Admiral Indemnity',
        email1: '',
        email2: '',
        fax1: '201-342-6381',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Admiral Insurance',
        email1: '',
        email2: '',
        fax1: '480-281-0910',
        fax2: '856-428-3390',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Adriatic Insurance',
        email1: '',
        email2: '',
        fax1: '504-832-0605',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Aegis Security Insurance',
        email1: '',
        email2: '',
        fax1: '717-657-0340',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Affiliates Insurance Company',
        email1: '',
        email2: '',
        fax1: '617-796-8359',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Affinity Mutual Insurance',
        email1: '',
        email2: '',
        fax1: '419-224-4874',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Aggressive Insurance',
        email1: 'contact.uw@aggressiveusa.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Agri General Insurance',
        email1: '',
        email2: '',
        fax1: '515-559-1001',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'AIG Property and Casualty Company',
        email1: '',
        email2: '',
        fax1: '212-770-0764',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'AIG Specialty Insurance Company',
        email1: '',
        email2: '',
        fax1: '212-770-7000',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'AIMCO Mutual Insurance',
        email1: '',
        email2: '',
        fax1: '336-605-7518',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'AIX Speciality Insurance',
        email1: '',
        email2: '',
        fax1: '508-853-6332',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Alfa Insurance',
        email1: '',
        email2: '',
        fax1: '334-613-4427',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Align General',
        email1: '',
        email2: '',
        fax1: '619-702-7077',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Alinsco Insurance Company',
        email1: 'policyservice@alinsco.com',
        email2: '',
        fax1: '817-231-4301',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'All America Insurance',
        email1: '',
        email2: '',
        fax1: '419-238-7626',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'ALLEGIANT',
        email1: '',
        email2: '',
        fax1: '808-585-3513',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Alliance Indemnity',
        email1: '',
        email2: '',
        fax1: '620-241-3157',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Alliance Insurance',
        email1: '',
        email2: '',
        fax1: '620-241-3157',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Allianz',
        email1: '',
        email2: '',
        fax1: '312-641-3797',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Allied',
        email1: '',
        email2: '',
        fax1: '866-315-1430',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: 'One West Nationwide Blvd 1-04-701, Columbus, OH 43215-2220',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Allstate',
        email1: '',
        email2: '',
        fax1: '866-546-9509',
        fax2: '847-402-9116',
        fax3: '847-326-5199',
        fax4: '847-326-7524',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '800-255-7828',
        specialInstructions: '',
        weight: 2
    },
    {
        priorCompany: 'Ambac Assurance',
        email1: '',
        email2: '',
        fax1: '212-208-3558',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Amco',
        email1: '',
        email2: '',
        fax1: '866-315-1430',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'America First',
        email1: '',
        email2: '',
        fax1: '603-357-4889',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'America National',
        email1: '',
        email2: '',
        fax1: '417-887-1801',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'American Access',
        email1: '',
        email2: '',
        fax1: '630-645-7788',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'American Family',
        email1: 'lifedocuments@amfam.com',
        email2: '',
        fax1: '',
        fax2: '608-243-4923',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '800-692-6326',
        specialInstructions: 'to get agent contact info for request'
    },
    {
        priorCompany: 'American Family Connect',
        email1: 'servicepromise@connectbyamfam.com',
        email2: '',
        fax1: '920-330-5607',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'American Modern Insurance Group',
        email1: '',
        email2: '',
        fax1: '800-217-5150',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'American Risk Insurance',
        email1: 'customerservice@americanriskins.com',
        email2: '',
        fax1: '713-559-0704',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: 'go to https://www.americanriskins.com to get correct fax number for individual state'
    },
    {
        priorCompany: 'American Strategic Insurance',
        email1: 'txendorsements@asicorp.org',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Ameriprise',
        email1: '',
        email2: '',
        fax1: '888-269-8408',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Ameritrust Group',
        email1: '',
        email2: '',
        fax1: '248-358-1614',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Amex Assurance Company',
        email1: '',
        email2: '',
        fax1: '623-492-3355',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Amfed Casualty Insurance',
        email1: '',
        email2: '',
        fax1: '601-427-1544',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Amgaurd Insurance',
        email1: '',
        email2: '',
        fax1: '570-823-5930',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Amica',
        email1: 'docs@amica.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Amica Mutual Ins',
        email1: '',
        email2: '',
        fax1: '866-602-8825',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Amtrust Financial',
        email1: '',
        email2: '',
        fax1: '212-220-7130',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Ark Insurance Services (agent)',
        email1: '',
        email2: '',
        fax1: '419-425-5190',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Arrowhead Insurance',
        email1: '',
        email2: '',
        fax1: '619-881-8694',
        fax2: '800-405-2014',
        fax3: '800-566-7650',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'ASI Assurance',
        email1: '',
        email2: '',
        fax1: '866-274-8765',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'ASI Preferred',
        email1: '',
        email2: '',
        fax1: '727-374-0464',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Assurance America',
        email1: 'customer_service@aainsco.com',
        email2: '',
        fax1: '770-952-0258',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Assurant',
        email1: 'mhmail@assurant.com',
        email2: '',
        fax1: '305-969-4171',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Auto Owners Insurance',
        email1: '',
        email2: '',
        fax1: '517-323-8796',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '800-346-0346',
        specialInstructions: ''
    },
    {
        priorCompany: 'AXA Insurance',
        email1: '',
        email2: '',
        fax1: '212-658-8636',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'AXIS Insurance',
        email1: '',
        email2: '',
        fax1: '678-746-9420',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'AXIS Specialty',
        email1: '',
        email2: '',
        fax1: '678-746-9320',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Badger Mutual',
        email1: '',
        email2: '',
        fax1: '414-383-1234',
        fax2: '414-383-4339',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Balboa Insurance',
        email1: '',
        email2: '',
        fax1: '949-222-8000',
        fax2: '949-222-8727',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Baldwin Mutual',
        email1: '',
        email2: '',
        fax1: '251-943-6335',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Bankers Insurance',
        email1: '',
        email2: '',
        fax1: '800-899-0146',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Banner Life Insurance',
        email1: '',
        email2: '',
        fax1: '301-279-4178',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Barnstable County Mutual',
        email1: '',
        email2: '',
        fax1: '508-362-8025',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Battle Creek Mutual',
        email1: '',
        email2: '',
        fax1: '402-675-2825',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Baxter International',
        email1: '',
        email2: '',
        fax1: '224-948-2000',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Bear River Mutual',
        email1: 'damon@cninsurance.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Berkshire Hathaway',
        email1: 'bhservices@bhhc.com',
        email2: '',
        fax1: '870-820-7968',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Bremen Farmers Mutual',
        email1: '',
        email2: '',
        fax1: '785-337-2414',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Bridgefield Casualty Insurance',
        email1: '',
        email2: '',
        fax1: '863-667-2738',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Bristol West',
        email1: '',
        email2: '',
        fax1: '888-888-0070',
        fax2: '800-776-5632',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'California Casualty',
        email1: '',
        email2: '',
        fax1: '888-206-3083',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Carnegie General',
        email1: '',
        email2: '',
        fax1: '805-445-1480',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Central Insurance Company',
        email1: 'billing@central-insurance.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '800-786-9052',
        specialInstructions: "to get agent's contact info for request"
    },
    {
        priorCompany: 'City National Insurance/Velocity',
        email1: 'info@velocityrisk.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Clearcover',
        email1: '',
        email2: '',
        fax1: '312-873-3741',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'CN insurance',
        email1: '',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Commonwealth Casualty Company',
        email1: '',
        email2: '',
        fax1: '877-635-1095',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Costco Connect',
        email1: 'servicepromise@connectbyamfam.com',
        email2: '',
        fax1: '920-330-5607',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Country Financial',
        email1: 'request@countryfinancial.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '866-268-6879',
        specialInstructions: "& get local agent's information"
    },
    {
        priorCompany: 'CSE Insurance',
        email1: 'customersupport@cseinsurance.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Dairyland Insurance',
        email1: 'plpcdocuments@sentry.com',
        email2: '',
        fax1: '800-943-3373',
        fax2: '715-346-8934',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Direct Auto',
        email1: '',
        email2: '',
        fax1: '877-622-7338',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'ELECTRIC INSURANCE',
        email1: 'service@ElectricInsurance.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Elephant Insurance',
        email1: 'customerservice@elephant.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Encompass Insurance',
        email1: '',
        email2: '',
        fax1: '800-924-0273',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Encova Insurance',
        email1: 'agp1@encova.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Equity Insurance Company',
        email1: 'uw@equityins.net',
        email2: '',
        fax1: '855-686-9457',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '800-352-8193',
        specialInstructions: ''
    },
    {
        priorCompany: 'Erie',
        email1: 'customercare@erieinsurance.com',
        email2: '',
        fax1: '814-870-3126',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Esurance',
        email1: 'customerservice@esurance.com',
        email2: '',
        fax1: '800-926-2869',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Explorer Insurance',
        email1: '',
        email2: '',
        fax1: '800-775-7210',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Farmers',
        email1: '',
        email2: '',
        fax1: '877-217-1389',
        fax2: '866-581-1410',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: 'send proof of replacement cov here'
    },
    {
        priorCompany: 'Farmers Mutual Fire Insurance Company of Salem County',
        email1: '',
        email2: '',
        fax1: '856-935-7955',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'FedNat Insurance',
        email1: '',
        email2: '',
        fax1: '954-733-7071',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'FIC Unitrin',
        email1: '',
        email2: '',
        fax1: '800-218-8553',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Fidelity National',
        email1: '',
        email2: '',
        fax1: '800-850-3299',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'First Acceptance',
        email1: 'cs@acceptanceinsurance.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'First American Insurance',
        email1: 'endorsements.fapci@firstam.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Fist Chicago',
        email1: '',
        email2: '',
        fax1: '708-552-4499',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Foremost',
        email1: '',
        email2: '',
        fax1: '800-325-1507',
        fax2: '877-452-3957',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Founders Insurance',
        email1: '',
        email2: '',
        fax1: '847-795-0080',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Freeway Insurance',
        email1: 'customercare@confie.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Fremont Insurance (Nustar Insurance Agerncy ,Inc MI',
        email1: '',
        email2: '',
        fax1: '231-544-6099',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'GAINSCO INSURANCE',
        email1: 'service@gainscoagency.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Geico',
        email1: 'r9@geico.com',
        email2: 'R5TechFax@geico.com',
        fax1: '855-814-4058',
        fax2: '877-294-8178',
        fax3: '866-238-5106',
        fax4: '855-810-0642',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: '',
        weight: 2
    },
    {
        priorCompany: 'Germania Insurance',
        email1: 'punderwriting@germaniainsurance.com',
        email2: '',
        fax1: '979-836-1977',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Goodville Mutual Casualty Company',
        email1: '',
        email2: '',
        fax1: '717-354-5158',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Grange',
        email1: '',
        email2: '',
        fax1: '866-550-9222',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: 'Agent must cancel'
    },
    {
        priorCompany: 'Hallmark',
        email1: 'service@hallmarkgrp.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Hanover',
        email1: 'clprocessla@hanover.com',
        email2: '',
        fax1: '517-546-1848',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Hartford',
        email1: 'agency.services@thehartford.com',
        email2: '',
        fax1: '877-293-2072',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: 'One Hartford Plaza, Hartford, CT 06155',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Hastings Mutual Insurance Company',
        email1: 'perprop@hastingsmutual.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'HCC Surity',
        email1: '',
        email2: '',
        fax1: '721-994-6001',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Hillstar',
        email1: '',
        email2: '',
        fax1: '866-994-4557',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '5500 Park West Drive, Bessemer, AL 35022',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Hippo',
        email1: 'support@myhippo.com',
        email2: 'lendersupport@hippo.com',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '800-585-0705',
        specialInstructions: ''
    },
    {
        priorCompany: 'Home Site',
        email1: 'customerservice@homesite.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Home State Insurance',
        email1: '',
        email2: '',
        fax1: '336-435-0918',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Homeowners of America Insurance',
        email1: 'customerservice@hoaic.com',
        email2: '',
        fax1: '469-417-0490',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Horace Mann',
        email1: 'corporatescanning@horacemann.com',
        email2: '',
        fax1: '217-788-5161',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Infinity',
        email1: '',
        email2: '',
        fax1: '800-782-2218',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: 'PO BOX 830189, Birmgingham, AL 35209',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Kemper',
        email1: 'customer.service@ipacc.com',
        email2: '',
        fax1: '800-782-2218',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'La Familia Insurance',
        email1: '',
        email2: '',
        fax1: '866-786-4991',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: 'Customer must call in to cancel'
    },
    {
        priorCompany: 'Lemonade',
        email1: 'member must call or email to cxl',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Liberty Mutual',
        email1: 'LMDOCUMENTS@LIBERTYMUTUAL.COM',
        email2: '',
        fax1: '866-241-0482',
        fax2: '877-600-5740',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Lighthouse Property Insurance',
        email1: '',
        email2: '',
        fax1: '833-966-1918',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Love Insurance',
        email1: '',
        email2: '',
        fax1: '214-824-7262',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Maison Insurance',
        email1: '',
        email2: '',
        fax1: '877-864-4936',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Maison Insurance Company',
        email1: '',
        email2: '',
        fax1: '954-733-7071',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '844-962-4766',
        specialInstructions: ''
    },
    {
        priorCompany: 'Mapfre Insurance',
        email1: '',
        email2: '',
        fax1: '508-671-4632',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Mendota Insurance Company',
        email1: 'mendotauw@mendota-insurance.com',
        email2: '',
        fax1: '800-843-9970',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Mercury Insurance',
        email1: '',
        email2: '',
        fax1: '888-513-9529',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Metlife',
        email1: 'policyupdate@metlife.com',
        email2: '',
        fax1: '877-217-1389',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Metromile',
        email1: 'admin@metromile.com',
        email2: 'customerservice@metromile.com',
        fax1: '888-244-1702',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: 'Customer must call in to cancel'
    },
    {
        priorCompany: 'Mission Select',
        email1: 'customerservice@missionselect.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Motorists Mutual',
        email1: 'agp1@encova.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Mountain Valley Indemnity Company',
        email1: '',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Mutual of Enumclaw',
        email1: '',
        email2: '',
        fax1: '360-825-6885',
        fax2: '800-366-5551',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'National General',
        email1: 'service@ngic.com',
        email2: '',
        fax1: '877-849-9022',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'National Indemnity',
        email1: '',
        email2: '',
        fax1: '402-536-3030',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'National Mutual Insurance Company',
        email1: '',
        email2: '',
        fax1: '877-423-5462',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Nationwide',
        email1: 'plpc@nationwide.com',
        email2: '',
        fax1: '800-811-5386',
        fax2: '614-221-6317',
        fax3: '866-902-0407',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Noblr Reciprocal Exc',
        email1: '',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: 'Customer must call in to cancel'
    },
    {
        priorCompany: 'Ohio Mutual Group',
        email1: '',
        email2: '',
        fax1: '419-562-0995',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'OLD AMERICAN CAPITAL INSURANCE',
        email1: '',
        email2: '',
        fax1: '214-561-1990',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Pact Insurance',
        email1: 'help@pactinsurance.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'PEKIN INSURANCE',
        email1: 'plsupport@pekininsurance.com',
        email2: '',
        fax1: '309-346-0836',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Pharmacists Mutual',
        email1: '',
        email2: '',
        fax1: '515-295-4355',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'PLYMOUTH ROCK ASSURANCE',
        email1: 'propertyservicing@plymouthrock.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Proctor Financial Inc',
        email1: '',
        email2: '',
        fax1: '248.269.5735',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Progressive',
        email1: 'upload@email.progressive.com',
        email2: '',
        fax1: '800-229-1590',
        fax2: '800-229-1590',
        fax3: '800-556-0014',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'QBE',
        email1: '',
        email2: '',
        fax1: '888-268-1554',
        fax2: '608-837-4418',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'RAM insurance',
        email1: '',
        email2: '',
        fax1: '218 879-7097',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Redpoint Mutual /Cover Financial',
        email1: 'coverclaims@littleongroup.com',
        email2: '',
        fax1: '512-708-9486',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Redwood Fire and Casualty',
        email1: '',
        email2: '',
        fax1: '415-675-5542',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '402-393-7255 x3063',
        specialInstructions: ''
    },
    {
        priorCompany: 'Reliant General',
        email1: '',
        email2: '',
        fax1: '858-592-0992',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: 'PO BOX 270339 San Diego, CA 92198',
        Phone: '800-929-9956',
        specialInstructions: ''
    },
    {
        priorCompany: 'Republic Group',
        email1: '',
        email2: '',
        fax1: '888-841-8372',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Root',
        email1: 'support@joinroot.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: '',
        weight: 2
    },
    {
        priorCompany: 'Safe Auto',
        email1: 'fFfF',
        email2: '',
        fax1: '614-456-2940',
        fax2: '614-456-2935',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'SAFECO',
        email1: 'documents@safeco.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'SAGESURE',
        email1: 'policyservices@sagesure.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Security National Insurance',
        email1: '',
        email2: '',
        fax1: '954-316-5218',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Sentry Insurance',
        email1: '',
        email2: '',
        fax1: '888-533-7827',
        fax2: '715-346-7876',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Shelter Mutual Insurance',
        email1: '',
        email2: '',
        fax1: '888-651-4255',
        fax2: '573-446-5726',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Southern Trust Insurance',
        email1: 'info@stins.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Spinnaker Insurance Company',
        email1: '',
        email2: '',
        fax1: '908-274-1989',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Star Casualty Insurance Company',
        email1: '',
        email2: '',
        fax1: '786-347-5535',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'State Auto',
        email1: 'sahelps@stateauto.com',
        email2: 'sahelps@stateauto.com',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'State Farm',
        email1: 'Info@statefarm.com',
        email2: '',
        fax1: '309-766-4655',
        fax2: '309-763-0307',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: true,
        MailingAddress: 'Corporate Headquarters State Farm Insurance One State Farm Plaza Bloomington, IL 61710',
        Phone: '800-782-8332 x0',
        specialInstructions: '& press 0 to get agent contact info',
        weight: 2
    },
    {
        priorCompany: 'State National',
        email1: '',
        email2: '',
        fax1: '877-400-8686',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Standard Casualty Insurance Co',
        email1: '',
        email2: 'cancel@stdins.com',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Stillwater Insurance',
        email1: 'ins@stillwater.com',
        email2: '',
        fax1: '866-877-6355',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Tapco General Liability',
        email1: '',
        email2: '',
        fax1: '336-584-8880',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: 'PO BOX 286 Burlington, NC 27216',
        Phone: '877-827-2699',
        specialInstructions: ''
    },
    {
        priorCompany: 'Texas Farm Bureau Mutual Insurance',
        email1: '',
        email2: '',
        fax1: '254-751-8712',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'The General Insurance',
        email1: '',
        email2: '',
        fax1: '800-467-8767',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Traders Insurance',
        email1: '',
        email2: 'underwriting@tradersauto.com',
        fax1: '800-943-3371',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Travelers',
        email1: 'piservice@travelers.com',
        email2: '',
        fax1: '800-943-3373',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Travelers/Consumers County Mutual',
        email1: 'piservice@travelers.com',
        email2: '',
        fax1: '800-943-3373',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Trexis',
        email1: 'customerservice@trexis.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Trisura Specialty Insurance Company',
        email1: 'TSIC.Underwriting@Trisura.com',
        email2: 'TIC.Underwriting@Trisura.com',
        fax1: '405-594-4969',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Twico The Woodlands  Ins',
        email1: '',
        email2: '',
        fax1: '281-298-8626',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'United Heritage Insurance',
        email1: '',
        email2: '',
        fax1: '208-493-6290',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Universal Property & Casualty Insurance',
        email1: 'endorsements@universalproperty.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'USAA',
        email1: '',
        email2: '',
        fax1: '800-531-8877',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '800-531-8722',
        specialInstructions: ''
    },
    {
        priorCompany: 'USLI',
        email1: '',
        email2: '',
        fax1: '610-688-4391',
        fax2: '949-860-3119',
        fax3: '512-712-1659',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Victoria Insurance',
        email1: '',
        email2: '',
        fax1: '800-955-0958',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Western Mutual Insurance',
        email1: 'service@westernmutual.com',
        email2: '',
        fax1: '949-838-0019',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Western Reserve',
        email1: '',
        email2: '',
        fax1: '800-392-7093',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'Western United',
        email1: '',
        email2: '',
        fax1: '949-852-5085',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '800-959-9842',
        specialInstructions: ''
    },
    {
        priorCompany: 'Westfield',
        email1: 'plprocessing@westfieldgrp.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'WESTFIELD INSURANCE',
        email1: 'plprocessing@westfieldgrp.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: 'WESTWOOD  INSURANCE',
        email1: 'cancellationgroup@insuranceemail.com',
        email2: '',
        fax1: '',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    },
    {
        priorCompany: "Workmen's Auto",
        email1: '',
        email2: '',
        fax1: '800-761-2305',
        fax2: '',
        fax3: '',
        fax4: '',
        needsAdditionalZendeskTicket: false,
        MailingAddress: '',
        Phone: '',
        specialInstructions: ''
    }
];
exports.default = insuranceProviderList;
//# sourceMappingURL=insuranceProviderList.js.map